module.exports = __webpack_public_path__ + "static/media/kneecap-up-4.26d1c416.png";